import { render } from "./InboxComponent.vue?vue&type=template&id=d9e58416&scoped=true"
import script from "./InboxComponent.vue?vue&type=script&lang=js"
export * from "./InboxComponent.vue?vue&type=script&lang=js"

import "./InboxComponent.vue?vue&type=style&index=0&id=d9e58416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e58416"]])

export default __exports__